import { useState, useEffect } from 'react';
import { BrowserRouter as Router, Route, Routes, Navigate } from 'react-router-dom';

import { useLoginQuery } from './MsalAccessProvider';
import { UserProvider } from './UserProvider';

import Navbar from './Navbar';
import Profile from './profile/Profile';
import Register from './profile/Register';
import Courses from './courses/Courses';
import Surveys from './surveys/Surveys';
import SignOut from './SignOut';

import loading from '../loading.gif';

function Root() {
  const [dim, setDim] = useState();
  const {data, isError, isLoading } = useLoginQuery();

  const fullPath = (...props) => `/${Object.values(props).join('/')}`;

  useEffect(() => {
    const resizeHandler = () => {
      setDim({height: window.innerHeight, width: window.innerWidth});
    };
    window.addEventListener('resize', resizeHandler);
  }, []);

  if (isError) {
    return (
      <div className="flex flex-col my-8">
        <div className="
        bg-cod-gray-light border-t-4 border-b-4 border-utrgv-orange
        text-2xl font-semibold text-utrgv-orange py-8 px-12">CS @ UTRGV</div>
        <div className="text-center pt-4 pb-2">
          Well, shoot. That didn't work.
        </div>
        <div className="text-center pt-4 pb-2">
          Please contact us at csci@utrgv.edu from your UTRGV email.
        </div>
      </div>
    );
  }

  if (isLoading || !data) {
    return (
      <div className="flex flex-col my-8">
        <div className="
        bg-cod-gray-light border-t-4 border-b-4 border-utrgv-orange
        text-2xl font-semibold text-utrgv-orange py-8 px-12">CS @ UTRGV</div>
        <div className="text-center pt-4 pb-2 italic">
          Signing in...
        </div>
        <div className="flex justify-center pt-4 pb-2">
          <img alt="Loading..." src={loading} className='w-12' />
        </div>
      </div>
    );
  }
  
  return (
    <>
    {data &&
      <UserProvider {...data}>
        <Router>
          <div className="w-full h-screen">
            {window.innerWidth > 640 && <Navbar signoutPath={fullPath(...data.containerPath, 'signout')} />}
            <div className="border-t border-utrgv-orange sm:border-none pb-20">
              <Routes>
                {/* global root default route */}
                <Route path='/' element={<Navigate to={fullPath(...data.containerPath, 'profile')} replace/>} />
                {/* container default route */}
                <Route path={fullPath(...data.containerPath)} element={<Navigate to={fullPath(...data.containerPath, 'profile')} replace/>} />
                {/* apps */}
                <Route path={fullPath(...data.containerPath, 'profile/*')} element={<Profile pathPrefix={fullPath(...data.containerPath, 'profile/')} />} />
                <Route path={fullPath(...data.containerPath, 'register/:requestToken')} element={<Register pathPrefix={fullPath(...data.containerPath, 'register/')} />} />
                <Route path={fullPath(...data.containerPath, 'courses/*')} element={<Courses pathPrefix={fullPath(...data.containerPath, 'courses/')} />} />
                <Route path={fullPath(...data.containerPath, 'surveys/*')} element={<Surveys pathPrefix={fullPath(...data.containerPath, 'surveys/')} />} />
                <Route path={fullPath(...data.containerPath, 'signout')} element={<SignOut />} />
              </Routes>
            </div>
            {window.innerWidth <= 640 &&
              <section id="bottom-navigation"
              className="block fixed inset-x-0 bottom-0 z-10">
                <Navbar signoutPath={fullPath(...data.containerPath, 'signout')} />
              </section>}
          </div>
        </Router>
      </UserProvider>}
    </>
  );
}

export default Root;
